import { Menu, Dropdown } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FaHandHolding } from 'react-icons/fa'
import { Link, Route, Switch } from 'react-router-dom'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData } from '../../modules'

import Receive from '../../components/reusable/receive'
import NewStockTakeTally from '../../components/modals/newStockTakeTally'
import StockTakeTally from '../../components/drawers/stockTakeTally'

const StockTake = () => {
    const [string, setString] = useState('')

    const { user } = useSelector(state => state.application)

    const [
        { loading: qLoading, error: qError, fetch: fetchTallies },
        { list: tallies },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('stockTakeTallies', {
        string,
        committed: false 
    }, { notify: true }, 'tallies')

    const [, { list: inventory }] = useListData('inventoryItems', {}, { notify: true }, 'items', 10000)

    const refresh = () => {
        navigate(1)
        fetchTallies()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Store Name" />
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">My Tallies</h2>
                    </span>
                    <span className="flex items-center justify-between">
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        {
                            (user?.issuperuser || user.stations?.some(st => st.name === 'stock-take' && (st.permissions.includes('create-stock-take-tally') || st.permissions.includes('*')))) &&
                            <Link className="ml-2" to="/app/stock-take/new">
                                <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                    <FaHandHolding />
                                    <span className="xs:block ml-2">New Stock Take</span>
                                </button>
                            </Link>
                        }
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={qLoading}
                        error={qError}>
                        {
                            tallies?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Store</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Created On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                tallies.map((tally, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {((page - 1) * limit) + (key + 1)}.
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{tally.store?.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{stringifyDate(tally.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-lef">{tally.committed ? 'Committed' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2 text-left">
                                                            <Dropdown
                                                                trigger={['click', 'hover']}
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={`/app/stock-take/${tally._id}`}><Menu.Item>View</Menu.Item></Link>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No tallies {string.trim().length > 2 ? `matching "${string}"` : ""} were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path="/app/stock-take/new">
                    <NewStockTakeTally onPerform={refresh} />
                </Route>
                <Route path="/app/stock-take/:id">
                    <StockTakeTally items={ inventory } onPerform={refresh} />
                </Route>
            </Switch>
        </div>
    )
}

export default StockTake